// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { getBrandHealthApiV3MetricsBrandsHealthPost, getBrandInsightsApiV3MetricsBrandsBrandIdInsightsPost, getBrandPostsApiV3MetricsBrandsBrandIdPostsPost, getBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPost, getConversationsApiV3ConversationsGet, getDigitalBrandMetricsApiV3MetricsBrandsDigitalPost, getFiltersApiV3MetricsFiltersGet, getMeApiV3MeGet, getMessagesApiV3ConversationsConversationIdMessagesGet, getPageInsightsApiV3InsightsPagePost, getTraditionalBrandMetricsApiV3MetricsBrandsTradPost, type Options, postChatMessageApiV3ChatPost } from '../sdk.gen';
import type { GetBrandHealthApiV3MetricsBrandsHealthPostData, GetBrandHealthApiV3MetricsBrandsHealthPostError, GetBrandHealthApiV3MetricsBrandsHealthPostResponse, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostError, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponse, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostError, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponse, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostError, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponse, GetConversationsApiV3ConversationsGetData, GetConversationsApiV3ConversationsGetError, GetConversationsApiV3ConversationsGetResponse, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostError, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponse, GetFiltersApiV3MetricsFiltersGetData, GetFiltersApiV3MetricsFiltersGetError, GetFiltersApiV3MetricsFiltersGetResponse, GetMeApiV3MeGetData, GetMeApiV3MeGetError, GetMeApiV3MeGetResponse, GetMessagesApiV3ConversationsConversationIdMessagesGetData, GetMessagesApiV3ConversationsConversationIdMessagesGetError, GetMessagesApiV3ConversationsConversationIdMessagesGetResponse, GetPageInsightsApiV3InsightsPagePostData, GetPageInsightsApiV3InsightsPagePostError, GetPageInsightsApiV3InsightsPagePostResponse, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostError, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponse, PostChatMessageApiV3ChatPostData, PostChatMessageApiV3ChatPostError, PostChatMessageApiV3ChatPostResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getMeApiV3MeGetQueryKey = (options?: Options<GetMeApiV3MeGetData>) => createQueryKey('getMeApiV3MeGet', options);

/**
 * Get Me
 */
export const getMeApiV3MeGetOptions = (options?: Options<GetMeApiV3MeGetData>) => queryOptions<GetMeApiV3MeGetResponse, AxiosError<GetMeApiV3MeGetError>, GetMeApiV3MeGetResponse, ReturnType<typeof getMeApiV3MeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeApiV3MeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeApiV3MeGetQueryKey(options)
});

/**
 * Post Chat Message
 */
export const postChatMessageApiV3ChatPostMutation = (options?: Partial<Options<PostChatMessageApiV3ChatPostData>>): UseMutationOptions<PostChatMessageApiV3ChatPostResponse, AxiosError<PostChatMessageApiV3ChatPostError>, Options<PostChatMessageApiV3ChatPostData>> => {
    const mutationOptions: UseMutationOptions<PostChatMessageApiV3ChatPostResponse, AxiosError<PostChatMessageApiV3ChatPostError>, Options<PostChatMessageApiV3ChatPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postChatMessageApiV3ChatPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationsApiV3ConversationsGetQueryKey = (options?: Options<GetConversationsApiV3ConversationsGetData>) => createQueryKey('getConversationsApiV3ConversationsGet', options);

/**
 * Get Conversations
 */
export const getConversationsApiV3ConversationsGetOptions = (options?: Options<GetConversationsApiV3ConversationsGetData>) => queryOptions<GetConversationsApiV3ConversationsGetResponse, AxiosError<GetConversationsApiV3ConversationsGetError>, GetConversationsApiV3ConversationsGetResponse, ReturnType<typeof getConversationsApiV3ConversationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversationsApiV3ConversationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationsApiV3ConversationsGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getConversationsApiV3ConversationsGetInfiniteQueryKey = (options?: Options<GetConversationsApiV3ConversationsGetData>): QueryKey<Options<GetConversationsApiV3ConversationsGetData>> => createQueryKey('getConversationsApiV3ConversationsGet', options, true);

/**
 * Get Conversations
 */
export const getConversationsApiV3ConversationsGetInfiniteOptions = (options?: Options<GetConversationsApiV3ConversationsGetData>) => infiniteQueryOptions<GetConversationsApiV3ConversationsGetResponse, AxiosError<GetConversationsApiV3ConversationsGetError>, InfiniteData<GetConversationsApiV3ConversationsGetResponse>, QueryKey<Options<GetConversationsApiV3ConversationsGetData>>, number | Pick<QueryKey<Options<GetConversationsApiV3ConversationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetConversationsApiV3ConversationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getConversationsApiV3ConversationsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationsApiV3ConversationsGetInfiniteQueryKey(options)
});

export const getMessagesApiV3ConversationsConversationIdMessagesGetQueryKey = (options: Options<GetMessagesApiV3ConversationsConversationIdMessagesGetData>) => createQueryKey('getMessagesApiV3ConversationsConversationIdMessagesGet', options);

/**
 * Get Messages
 */
export const getMessagesApiV3ConversationsConversationIdMessagesGetOptions = (options: Options<GetMessagesApiV3ConversationsConversationIdMessagesGetData>) => queryOptions<GetMessagesApiV3ConversationsConversationIdMessagesGetResponse, AxiosError<GetMessagesApiV3ConversationsConversationIdMessagesGetError>, GetMessagesApiV3ConversationsConversationIdMessagesGetResponse, ReturnType<typeof getMessagesApiV3ConversationsConversationIdMessagesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMessagesApiV3ConversationsConversationIdMessagesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMessagesApiV3ConversationsConversationIdMessagesGetQueryKey(options)
});

export const getFiltersApiV3MetricsFiltersGetQueryKey = (options?: Options<GetFiltersApiV3MetricsFiltersGetData>) => createQueryKey('getFiltersApiV3MetricsFiltersGet', options);

/**
 * Get Filters
 */
export const getFiltersApiV3MetricsFiltersGetOptions = (options?: Options<GetFiltersApiV3MetricsFiltersGetData>) => queryOptions<GetFiltersApiV3MetricsFiltersGetResponse, AxiosError<GetFiltersApiV3MetricsFiltersGetError>, GetFiltersApiV3MetricsFiltersGetResponse, ReturnType<typeof getFiltersApiV3MetricsFiltersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFiltersApiV3MetricsFiltersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFiltersApiV3MetricsFiltersGetQueryKey(options)
});

/**
 * Get Traditional Brand Metrics
 */
export const getTraditionalBrandMetricsApiV3MetricsBrandsTradPostMutation = (options?: Partial<Options<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData>>): UseMutationOptions<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponse, AxiosError<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostError>, Options<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData>> => {
    const mutationOptions: UseMutationOptions<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponse, AxiosError<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostError>, Options<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getTraditionalBrandMetricsApiV3MetricsBrandsTradPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Digital Brand Metrics
 */
export const getDigitalBrandMetricsApiV3MetricsBrandsDigitalPostMutation = (options?: Partial<Options<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData>>): UseMutationOptions<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponse, AxiosError<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostError>, Options<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData>> => {
    const mutationOptions: UseMutationOptions<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponse, AxiosError<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostError>, Options<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getDigitalBrandMetricsApiV3MetricsBrandsDigitalPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Brand Health
 */
export const getBrandHealthApiV3MetricsBrandsHealthPostMutation = (options?: Partial<Options<GetBrandHealthApiV3MetricsBrandsHealthPostData>>): UseMutationOptions<GetBrandHealthApiV3MetricsBrandsHealthPostResponse, AxiosError<GetBrandHealthApiV3MetricsBrandsHealthPostError>, Options<GetBrandHealthApiV3MetricsBrandsHealthPostData>> => {
    const mutationOptions: UseMutationOptions<GetBrandHealthApiV3MetricsBrandsHealthPostResponse, AxiosError<GetBrandHealthApiV3MetricsBrandsHealthPostError>, Options<GetBrandHealthApiV3MetricsBrandsHealthPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getBrandHealthApiV3MetricsBrandsHealthPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Brand Insights
 */
export const getBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostMutation = (options?: Partial<Options<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData>>): UseMutationOptions<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponse, AxiosError<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostError>, Options<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData>> => {
    const mutationOptions: UseMutationOptions<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponse, AxiosError<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostError>, Options<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getBrandInsightsApiV3MetricsBrandsBrandIdInsightsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Brand Tab Analysis
 */
export const getBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostMutation = (options?: Partial<Options<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData>>): UseMutationOptions<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponse, AxiosError<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostError>, Options<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData>> => {
    const mutationOptions: UseMutationOptions<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponse, AxiosError<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostError>, Options<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Brand Posts
 */
export const getBrandPostsApiV3MetricsBrandsBrandIdPostsPostMutation = (options?: Partial<Options<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData>>): UseMutationOptions<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponse, AxiosError<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostError>, Options<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData>> => {
    const mutationOptions: UseMutationOptions<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponse, AxiosError<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostError>, Options<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getBrandPostsApiV3MetricsBrandsBrandIdPostsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Page Insights
 */
export const getPageInsightsApiV3InsightsPagePostMutation = (options?: Partial<Options<GetPageInsightsApiV3InsightsPagePostData>>): UseMutationOptions<GetPageInsightsApiV3InsightsPagePostResponse, AxiosError<GetPageInsightsApiV3InsightsPagePostError>, Options<GetPageInsightsApiV3InsightsPagePostData>> => {
    const mutationOptions: UseMutationOptions<GetPageInsightsApiV3InsightsPagePostResponse, AxiosError<GetPageInsightsApiV3InsightsPagePostError>, Options<GetPageInsightsApiV3InsightsPagePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getPageInsightsApiV3InsightsPagePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
